export const TableLoadingRow = ({ colSpan }) => (
    <tr>
        <td colSpan={colSpan} className="text-center py-4">
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading</span>
            </div>
        </td>
    </tr>
)

export const TableErrorRow = ({ colSpan }) => (
    <tr>
        <td colSpan={colSpan} className="text-center py-4 text-danger">
            Failed to load records. Please try again.
        </td>
    </tr>
)

export const TableEmptyRow = ({ colSpan, message }) => (
    <tr>
        <td colSpan={colSpan} className="text-center py-4 text-muted">{message}</td>
    </tr>
)
